/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ITranslation, rollerMapReferencedTranslation } from '@roller/translate-compiler';
import { AppConfigService } from '@core/app-config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class RollerTranslateLoaderService implements TranslateLoader {
  private readonly defaultLanguageCode = 'en';

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient
  ) {}

  /** Overrides TranslateLoader method to create an appropriate url to load translation file from. */
  getTranslation(lang: string): Observable<ITranslation> {
    return this.loadTranslation(this.defaultLanguageCode, lang).pipe(map((t) => rollerMapReferencedTranslation(t)));
  }

  /** Loads the translation file itself with a httpClient call.  */
  protected loadTranslation(defaultLanguageCode: string, lang: string): Observable<ITranslation> {
    if (lang === defaultLanguageCode) {
      return this.getEnglishTranslations();
    }

    const version = this.appConfigService.getEnvValue<string>('version') || '0.0.0';
    const cdnUrl = this.appConfigService.getEnvValue<string>('cdnUrl');
    const appId = this.appConfigService.getAppValue<string>('appId') || 'ecom';
    const otherLanguageUrl = `${cdnUrl.replace(/\/?$/, '/')}translations/translate-${appId}-${lang}.json?v=${version}`;

    return this.http.get<ITranslation>(otherLanguageUrl).pipe(catchError(() => this.getEnglishTranslations()));
  }

  private getEnglishTranslations(): Observable<ITranslation> {
    const defaultLanguageUrl = '/assets/i18n/en.json';
    return this.http.get<ITranslation>(defaultLanguageUrl);
  }
}
